import {inject, PLATFORM_ID} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {isPlatformBrowser} from '@angular/common';
import {TranslateHelperService} from '@services';

const SUPPORTED_LANGS = ['fr', 'en', 'it', 'de', 'es'];

export const languageGuard: CanActivateFn = (route) => {
	const router = inject(Router);
	const translateService = inject(TranslateHelperService);
	const platformId = inject(PLATFORM_ID);
	const isBrowser = isPlatformBrowser(platformId);
	const lang = route.paramMap.get('lang');
	if (!lang || !SUPPORTED_LANGS.includes(lang)) {
		const targetLang = SUPPORTED_LANGS.includes(translateService.currentLang) ? translateService.currentLang : 'fr';
		router.navigate([`/${targetLang}`]);
		return false;
	}
	if (translateService.currentLang !== lang) {
		translateService.switchLanguage(lang);
	}
	if (isBrowser) {
		document.documentElement.lang = lang;
	}
	return true;
};

export const redirectToLocaleGuard: CanActivateFn = (_route, state) => {
	const router = inject(Router);
	const translateService = inject(TranslateHelperService);
	const platformId = inject(PLATFORM_ID);
	const isBrowser = isPlatformBrowser(platformId);
	if (!isBrowser) {
		return router.parseUrl('/fr');
	}
	const currentLang = SUPPORTED_LANGS.includes(translateService.currentLang) ? translateService.currentLang : 'fr';
	const rawUrl = state.url || '/';
	const normalized = rawUrl.startsWith('/') ? rawUrl : `/${rawUrl}`;
	const firstSegment = normalized.split('/').filter(Boolean)[0];
	if (firstSegment && SUPPORTED_LANGS.includes(firstSegment)) {
		router.navigateByUrl(`/${firstSegment}`);
		return false;
	}
	const target = normalized === '/' ? `/${currentLang}` : `/${currentLang}${normalized}`;
	router.navigateByUrl(target);
	return false;
};

export const supportedLangs = SUPPORTED_LANGS;
